import React from "react";
import { Button, TextField, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useIntl } from "react-intl";
import { PropTypes } from "prop-types";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";

const useStyles = makeStyles((theme) => ({
  search: {
    display: "flex",
    flexDirection: "row",
    "& .MuiInputBase-input": {
      color: theme.palette.text.main + "!important",
      border: `1px solid ${theme.palette.disabled.main}`,
      borderTopLeftRadius: 30,
      borderBottomLeftRadius: 30,
      padding: "0.8rem",
    },
    "& button": {
      color: "white !important",
      borderTopRightRadius: 30,
      borderBottomRightRadius: 30,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      backgroundColor: theme.palette.secondary.main + "!important",
      padding: "0 1rem",
      "&:disabled": {
        backgroundColor: theme.palette.disabled.main + "!important",
      },
    },
  },
  buttonContent: {
    display: "flex",
    gap: theme.spacing(1),
  },
  firstCap: {
    textTransform: "lowercase !important",
    "&:first-letter": {
      textTransform: "capitalize !important",
    },
  },
}));

const SearchBarComponent = ({ handleChange, handleKeyDown, handleClick, placeholder, disabled }) => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <div className={classes.search}>
      <TextField
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={intl.formatMessage({ id: placeholder })}
      />
      <Button disabled={disabled} onClick={handleClick}>
        <div className={classes.buttonContent}>
          <SearchRoundedIcon />
          <Typography className={classes.firstCap}>
            {intl.formatMessage({ id: "searchOmimComponent.searchButton" })}
          </Typography>
        </div>
      </Button>
    </div>
  );
};

SearchBarComponent.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleKeyDown: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

SearchBarComponent.defaultProps = {
  disabled: false,
};

export default SearchBarComponent;
